export default __webpack_public_path__ + "static/media/icons-notification.51ba35ce.svg";